import { ROUTE_PATHS_WITHOUT_SHARE } from 'modules/routes/constants/index.cjs'

export default function hasShareRouteUtil (pathname) {
  return !ROUTE_PATHS_WITHOUT_SHARE.some(
    pathWithoutAuthorRow => !pathname.indexOf(pathWithoutAuthorRow)
  )
}
